//-- Copyright (c) 2021 TMT Insights Group, LLC
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { RowColumns } from './DailyReportsWidget';

interface DailyReportsHeaderRowProps {
  columns: RowColumns;
  offsetForScrollbar: boolean;
  includeCreatedBy?: boolean;
}

export const DailyReportsHeaderRow = ({ columns, offsetForScrollbar = false, includeCreatedBy = false }: DailyReportsHeaderRowProps) => {
  if (includeCreatedBy) columns['file_name'].cols = 4;
  if (!includeCreatedBy) columns['file_name'].cols = 6;
  return (
    <HeaderGrid container sx={{ pr: offsetForScrollbar ? 15 : 0 }}>
      {Object.keys(columns).map((key) => {
        if (key === 'created_by' && !includeCreatedBy) return null;
        return (
          <ColumnLabelGrid
            key={key}
            item
            xs={columns[key].cols}
            style={{
              display: 'flex',
              justifyContent: columns[key].align
            }}
          >
            {columns[key].label}
          </ColumnLabelGrid>
        );
      })}
    </HeaderGrid>
  );
};

const HeaderGrid = styled(Grid)`
  padding: ${({ theme }) => theme.spacing(0, 2, 1, 0)};
`;

const ColumnLabelGrid = styled(Grid)`
  align-items: center;
  font-size: 0.9rem;
  opacity: 0.6;
`;
